import { AppModule } from 'app/module';
import { trackGa4 } from 'util/googleAnalytics';

import './styles.scss';
import Template from './template.hbs';

export class LoadMoreJobsButton extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    getPropsFromDom() {
        return {
            active: !!this.dom.button,
            showLoadingDots: false,
            number: this.dom.button ? this.dom.button.getAttribute('data-number') : false,
            next: this.dom.button ? this.dom.button.getAttribute('data-next') : false,
        };
    }

    domBindings() {
        return {
            button: '.m-loadMoreJobsButton__button',
        };
    }

    domEvents() {
        if (this.dom.button) {
            this.dom.button.addEventListener('click', (e) => this.eventClicked(e));
        }
    }

    eventClicked(e) {
        this.buttonAction(e.currentTarget.getAttribute('data-page'));

        const eventCategory = document.documentElement.getAttribute('data-event-category');
        let contentType = '';

        if (eventCategory === 'page: jobs') {
            contentType = 'Job Search';
        } else if (eventCategory === 'page: jobalarm') {
            contentType = 'Job Alarm';
        } else if (eventCategory === 'page: watchlist') {
            contentType = 'Job Watchlist';
        }

        trackGa4({
            event: 'load_more',
            content_type: contentType,
        });
    }

    buttonAction(page) {
        if (parseInt(page, 10) > -1) {
            this.events.emit('load', { page });
            this.enableLoadingDots();
        }
    }

    getJobsSearchProps() {
        const data = {};
        if (this.dom.button) {
            data.page = parseInt(this.dom.button.getAttribute('data-number'), 10);
        }
        return data;
    }

    enableLoadingDots() {
        this.updateProps({ showLoadingDots: true }, true);
    }
}
